module.exports = __webpack_public_path__ + "static/scale-model-of-candy-cane-lane-in-inglewood-california-60fad23ca6b3cf8ab0494901638b4c6d.png";